<i18n lang="yaml">
en:
  title: 'Regions and Availability Zones'
ru:
  title: 'Регионы и зоны доступности'
</i18n>

<template>
  <s-section
    type="gray"
    is-centered
    :title="$t('title')"
    class="cloud-zones"
  >
    <img
      v-if="$i18n.locale === 'ru'"
      v-lazy-load
      alt="Регионы и зоны доступности Selectel"
      :data-src="require('~/assets/images/services/cloud/cloud-map-ru.svg?inline').default"
    >
    <img
      v-else
      v-lazy-load
      alt="Selectel Regions and Availability Zones"
      :data-src="require('~/assets/images/services/cloud/cloud-map-en.svg?inline').default"
    >
  </s-section>
</template>

<script>
export default {
  name: 'CloudZones'
}
</script>

<style lang="scss">
.cloud-zones {
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
  }
}
</style>